import { post } from '@/utils/network'

export default new class TeachingResearchApi {
    // 查看管理员权限教研室个数
    createOfficeNum() {
        return post<{ num: number }>('VirtualTeachingAndResearchOffices/createOfficeNum')
    }
    // 申请创建教研室
    applyForOpeningTeachingResearchSection(params: {
        username: string,
        school: string,
        mobile: string,
        code: string,
        options: string
    }) {
        return post('ResourceApi/applyForOpeningTeachingResearchSection', params)
    }
    /**
     * 创建虚拟教研室
     * @param params
     * @param {string} params.title 虚拟教研室标题
     * @param {string} params.cover_image 	封面图
     * @param {string} params.scope 建设范围
     * @param {string[]} params.organizations 发起机构
     * @param {string} params.content_type 	建设内容
     * @param {string} params.description 虚拟教研室描述
     */
    createOffice(params: {
        title: string;
        cover_image: string;
        scope: string;
        organizations: string[];
        content_type: string;
        description: string;
        type: '3';
    }) {
        return post('ResourceApi/addResource', params)
    }

    /**
     * 我的虚拟教研室列表
     */
    myOffices(params: {
        page: number,
        page_size: number,
        type: string
    }) {
        return post('VirtualTeachingAndResearchOffices/myOffices', params);
    }
    // 教研室广场
    officeSquare(params: {
        page: number,
        page_size: number,
        scope: string;
        content_type: string;
        keyword: string;
    }) {
        return post('VirtualTeachingAndResearchOffices/officeSquare', params)
    }
    // 解散虚拟教研室
    delResource(params: { resourceid: string }) {
        return post('ResourceApi/delResource', params);
    }

    getWareLabel(params: { resourceid: string }) {
        return post('/ResourceApi/getWareLabel', params);
    }
    // 添加标签
    addWareLabel(params: {
        resourceid: string,
        label_name: string,
        label_id?: string,
    }) {
        return post('ResourceApi/addWareLabel', params)
    }
    // 删除标签
    delWareLabels(params: { resourceid: string, id: string }) {
        return post('/ResourceApi/delWareLabels', params)
    }

    /**
     * 移除教研室成员
     */
    delMember(params: { resourceid: string, uids: string[] }) {
        return post('PrepareLessonsGroupApi/delMember', params)
    }
    /**
     * 获取教研室详情
     */
    getOfficeDetails(params: { resourceid: string }) {
        return post('VirtualTeachingAndResearchOffices/officeDetails', params)
    }

    //教研讨论/活动--获取公告板
    getNotify(params: { resourceid: string, type: string, content: string }) {
        return post('Futurev2/TencentMeeting/notify', params)
    }
    getMemberLists(params: {
        resourceid: string;
        currentPage: number;
        pageSize: number;
        search: string;
    }) {
        return post('PrepareLessonsGroupApi/getLists', params)
    }
    // 【成员】编辑虚拟教研室成员信息
    addMember(params: { resourceid: string, account: string, role: string }) {
        return post('PrepareLessonsGroupApi/addMember', params)
    }
    // 【成员】编辑虚拟教研室成员信息
    editMember(params: {
        resourceid: string;
        uid: string;
        nickname: string;
        school: string;
        avatar: string;
        member_title: string;
        description: string;
        honour_role: string;
    }) {
        return post('VirtualTeachingAndResearchOffices/editMember', params)
    }
    // 【成员】变更教研室成员角色
    changeRole(params: {
        resourceid: string;
        uid: string;
        role: string;
    }) {
        return post('PrepareLessonsGroupApi/changeRole', params)
    }
    // 【成员】移交教研室管理员
    transfer(params: {
        resourceid: string;
        uid: string;
        username: string;
    }) {
        return post('PrepareLessonsGroupApi/transfer', params);
    }

    // 【成员】申请加入列表
    joinApplyMembers(params: {
        resourceid?: string;
        page: number;
        page_size: number;
        keyword: string;
    }) {
        return post('VirtualTeachingAndResearchOffices/joinApplyMembers', params);
    }
    // 【成员】审批接口
    joinReview(params: {
        resourceid: string;
        target_uid: string;
        pass: number;
        role: string;
    }) {
        return post('VirtualTeachingAndResearchOffices/joinReview', params);
    }

    // 【成员】 获取团队配置
    getTeamConfig(params: { resourceid: string }) {
        return post('VirtualTeachingAndResearchOffices/getTeamConfig', params)
    }
    // 【成员】团队设置
    officeTeamConfig(params: {
        resourceid: string;
        auto_pass_join_apply: number
    }) {
        return post('VirtualTeachingAndResearchOffices/officeTeamConfig', params);
    }

    /**
     * 编辑虚拟教研室
     * @param params 参数
     * @param params.resourceid 虚拟教研室ID
     * @param params.title 虚拟教研室标题
     * @param params.cover_image 封面图
     * @param params.scope 建设范围
     * @param {string[]} params.organizations 发起机构
     * @param params.content_type 建设内容
     * @param params.description 虚拟教研室描述
     */
    updateResource(params: {
        resourceid: string;
        title: string;
        cover_image: string;
        scope: string;
        organizations: string[];
        content_type: string;
        description: string;
    }) {
        return post('ResourceApi/updateResource', params)
    }

    // 【门户】 获取虚拟教研室主页配置
    getPortalPageConfig(params: { resourceid: string }) {
        return post('VirtualTeachingAndResearchOffices/getPortalPageConfig', params)
    }
    // 【门户】主页搭建
    portalPageConfig(params: {
        resourceid: string;
        data_items: {
            [key: string]: {
                enable: number
                source: string
                value: number
            }
        },
        content_items: {
            [key: string]: {
                enable: number
            }
        }
    }) {
        return post('VirtualTeachingAndResearchOffices/portalPageConfig', params)
    }

    // 【门户】 虚拟教研室门户首页
    getHomepageDetail(params: { resourceid: string }) {
        return post('VirtualTeachingAndResearchOfficePortalPage/page', params);
    }

    // 【门户】 申请加入教研室
    joinApply(params: {
        resourceid: string;
        nickname: string;
        school: string;
        member_title: string;
    }) {
        return post('VirtualTeachingAndResearchOfficePortalPage/joinApply', params);
    }

    getAppliedCourse(params: {
        resourceid: string;
        page: number,
        size: number
    }) {
        return post('CourseApi/getVirtualTeachingResearchSectionCourseCite', params);
    }


    // 【教研室设置】变更建设主体
    editBuildBodyType(params: {
        resourceid: string;
        body_type: string
    }) {
        return post('VirtualTeachingAndResearchOffices/editBuildBodyType', params)
    }

    // 样板课程目录结构列表
    getResourceCourseDirectory(params: { resourceid: string }) {
        return post('CourseApi/getResourceCourseDirectory', params);
    }

    //样板课程共建--创建课程
    createCourse(params: { resourceid: string, coursename: string, teaching_object: string, teaching_material: string, credits: string }) {
        return post('CourseApi/addVirtualTeachingResearchSectionCourse', params)
    }
    //样板课程共建--编辑课程
    editCourse(params: { resourceid: string, courseid: string, coursename: string, teaching_object: string, teaching_material: string, credits: string }) {
        return post('CourseApi/saveVirtualTeachingResearchSectionCourse', params)
    }
    //样板课程共建--删除课程
    removeCourse(params: { resourceid: string, courseid: string }) {
        return post('CourseApi/delVirtualTeachingResearchSectionCourse', params)
    }
    //样板课程共建--复制课程
    copyCourse(params: { resourceid: string, srcCourseid: string, coursename: string, teaching_object: string, teaching_material: string, credits: string }) {
        return post('CourseApi/copyVirtualTeachingResearchSectionCourse', params)
    }
    //样板课程共建--获取课程列表
    getCourseList(params: { resourceid: string }) {
        return post('CourseApi/getVirtualTeachingResearchSectionCourse', params)
    }
    //样板课程共建--样本课程统计
    getCourseReferenced(params: { resourceid: string, courseid: string, page: number, size: number }) {
        return post('CourseApi/getVirtualTeachingResearchSectionCourseStatistical', params)
    }
    //虚拟教研室申请发布到广场
    // applyPublishToSquare(params:{resourceid: string}){
    //   return post('VirtualTeachingAndResearchOffices/applyPublishToSquare', params)
    // }
    //【虚拟教研室主体】 获取主体列表
    getTargetList(params: { resourceid: string, page: number, page_size: number }) {
        return post('VirtualTeachingAndResearchOfficeBuildBody/list', params)
    }
    //【虚拟教研室主体】 添加虚拟教研室主体
    createTargetList(params: any) {
        return post('VirtualTeachingAndResearchOfficeBuildBody/create', params)
    }
    //【虚拟教研室主体】编辑教研室主体
    editTargetList(params: any) {
        return post('VirtualTeachingAndResearchOfficeBuildBody/edit', params)
    }
    //【虚拟教研室主体】 删除主体
    removeTargetList(params: { body_id: string }) {
        return post('VirtualTeachingAndResearchOfficeBuildBody/delete', params)
    }

    //【虚拟教研室主题】通过关键字搜索主题
    searchTopic(params: { keyword: string }) {
        return post('Futurev2/Topic/search', params)
    }
    //【虚拟教研室主题】保存最后一次操作的主题
    saveSelectTopicOptions(params: { office_id: string, topics: Array<string> }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivity/saveSelectTopicOptions', params)
    }
    //【虚拟教研室主题】创建主题
    createTopic(params: { title: string, office_id: string }) {
        return post('Futurev2/Topic/create', params)
    }
    //【虚拟教研室主题】获取历史主题
    getSelectTopicOptions(params: { office_id: string }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivity/getSelectTopicOptions', params)
    }
    //【虚拟教研室主题】编辑主题
    editSelectTopicOptions(params: { office_id: string, activity_id: string, topics: Array<string> }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivity/editTopics', params)
    }
    //【虚拟教研室主题】主题推荐
    referrerTopics(params: { keyword: string }) {
        return post('Futurev2/VtrRecommend/topics', params)
    }
    //【虚拟教研室主题】教研室话题推荐
    referrerSubjects(params: { keyword: string }) {
        return post('Futurev2/VtrRecommend/subjects', params)
    }
    // 【虚拟教研室推荐】教研室推荐
    VtrRecommendOffices(params: { keyword: string }) {
        return post('/Futurev2/VtrRecommend/offices', params)
    }
    // 【研讨活动】创建教研活动
    createOfficeDiscuss(params: { office_id: string, type: string }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivitySubject/create', params)
    }
    // 【研讨活动】编辑教研活动
    editOfficeDiscuss(params: { activity_id: string, office_id: string, title: string, content: string }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivitySubject/edit', params)
    }
    // 【研讨活动】研讨活动列表
    getActivitiesList(params: { office_id: string, type: string, page: number, page_size: number }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivity/list', params)
    }
    // 【虚拟教研室】增加最新研讨功能
    latestDiscussActivity(params: { office_id: string }) {
        return post('/VirtualTeachingAndResearchOffices/latestDiscussActivity', params)
    }
    // 【研讨活动】删除研讨活动
    removeActivitiesList(params: { activity_id: string, office_id: string }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivity/delete', params)
    }
    // 【研讨活动】虚拟教研室研讨详情页
    getDetails(params: { office_id: string, activity_id: string }) {
        return post('Futurev2/VirtualTeachingAndResearchOfficeDiscussActivity/details', params)
    }
    // 【主题】获取全部教研室列表
    getOfficeActivitiesList(params: { topic_id: string, office_id?: string }) {
        return post('Futurev2/topic/officeActivities', params)
    }
    // 【主题】获取主题详情
    getThemeDetails(params: { topic_id: string }) {
        return post('Futurev2/topic/details', params)
    }

    //***评论接口***//

    // 发布评论
    postComment(params: { office_id: string, post_id: string, source: number, comment_id?: string, comment_content: string }) {
        return post('Futurev2/PostNews/commentAdd', params)
    }
    //获取评论列表
    getCommentLists(params: { office_id: string, post_id: string, source: number, comment_id?: string, page: number, page_size: number, order: string }) {
        return post('Futurev2/PostNews/commentLists', params)
    }
    //删除评论
    removeCommentItem(params: { id: string }) {
        return post('Futurev2/PostNews/commentDelete', params)
    }
    //评论点赞
    commentLike(params: { id: string }) {
        return post('Futurev2/PostNews/commentLike', params)
    }
    // 给来源类型点赞/取消点赞
    setDoLike(params: { office_id: string, post_id: string, source: number, data_id?: string, }) {
        return post('Futurev2/PostNews/doLike', params)
    }
    //获取动态列表
    getDynamicStateList(params: { office_id: string, page: number, page_size: number }) {
        return post('Futurev2/postNews/lists', params)
    }

    // 获取备课区/教研室资源库的列表
    resourceContentAllList(params: {
        resourceid: string
        type: string | number
        currentPage: number | string
        sort: number | string
        search: string
        folderid?: string
        pageSize?: number | string
        label_id?: string
    }) {
        return post('ResourceApi/resourceContentAllList', params)
    }

    // 题库 试题-列表分页
    getQuestionBankQuestion(params: {
        resourceid: string
        currentPage: number | string
        pageSize: number | string
    }) {
        return post('ResourceSubjectBank/getSubjectList', params)
    }

    // 题库 试题-删除
    deleteQuestion(params: { subjectid: string }) {
        return post('/ResourceSubjectBank/delSingleSubject', params)
    }
    // 添加到课程
    addCourseContentByResource(params: {
        resourceid: string,
        source: [any],
        target: any[]
    }) {
        return post('/ResourceApi/addCourseContentByResource', params)
    }
    // 课程内容引用到课程
    addVirtualCourseContentByResource(params: {
        resourceid: string,
        courseid: string,
        source:any[],
        target: any[]
    }) {
        return post('/FutureV2/CourseMeans/citeCourseContent', params)
    }
    // 删除资源库文件夹
    delResourceFolderFile(params: {
        resourceid: string,
        folderid?: string,
        fileid?: string,
        type: string,
    }) {
        return post('/ResourceApi/delResourceFolderFile', params)
    }
    //获取虚拟教研室的简版信息
    getBasicInfo(params: { office_id: string }) {
        return post('/VirtualTeachingAndResearchOfficePortalPage/getBasicInfo', params)
    }
    //获取资源的详情
    /**
     * type 0 作业  1 资料  2互动课件  3测试  4话题  7 公告
     * @param params 
     * @returns 
     */
    getResourceCoursewareDataInfo(params: { office_id: string, fileid?: string, post_id: string, type: number }) {
        return post('/Futurev2/Resource/getInfo', params)
    }
    //获取试卷的试题列表
    getResourceTestpaperSubjectList(params: { resourceid: string, testpaperid?: string, option: string }) {
        return post('/ResourceTestpaperApi/getSubjectList', params)
    }
    //获取试卷的类型统计
    getSubjectTypeStatistics = (params: { testpaperid: any, option: any }) => {
        return post('ResourceTestpaperApi/getSubjectTypeStatistics', params)
    }
    //获取某个课件的试题列表
    getInteractPPTSlides(params: { interactid: string, isneedSubjectCount: string }) {
        return post('/ResourceInteractPPTApi/listSlides', params)
    }
    //获取互动答题环节的试题列表
    getInteractStepSubjectLists(params: { interactid: string, pageindex: string }) {
        return post('/ResourceInteractPPTApi/getSubjectLists', params);
    }
    //行为上报
    addActionLog(params: { office_id: string, post_id: string, source: number, data_id?: string, type: number }) {
        return post('/Futurev2/postNews/addActionLog', params)
    }

    // 首页小铃铛
    hasRing() {
        return post<{
            // 状态
            status: number,
            // 点赞
            _enjoy_: number,
            // 评论
            _comment_: number,
            // 审核数
            _check_: number
        }>('/Futurev2/Bell/hasRing')
    }
    // 小铃铛消消乐
    clearRing(params: { type: string }) {
        return post('/Futurev2/Bell/clearRing', params)
    }
    // 通知列表
    ringLists(params: { type: string }) {
        return post('/Futurev2/Bell/ringLists', params)
    }
}